module.exports = __webpack_public_path__ + "static/flags/BM-513d6fc80d7f76bf71d2ece0cc0c4d81.gif";